<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>
    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div class="content-page-header">
          <h5>
            <router-link to="/estimates" style="color: #28084b">
              <i class="feather feather-arrow-left me-1"></i> </router-link
            >Add Estimate
          </h5>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="form-group-item border-0 mb-0">
                  <div class="row align-item-center">
                    <div class="row">
                      <div class="form-group col-lg-3 col-md-3">
                        <label>Estimate Number</label>
                        <input
                          type="text"
                          v-model="form.estimate_id"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group-bank col-lg-6 mb-0">
                        <div class="form-group notes-form-group-info">
                          <label>Description</label>
                          <textarea
                            class="form-control"
                            v-model="form.description"
                            placeholder="Enter Description"
                          ></textarea>
                        </div>
                      </div>
                      <div
                        class="form-group col-lg-6 d-flex flex-column align-items-start"
                      >
                        <label class="d-none d-lg-block" style="color: #ffffff"
                          >Des</label
                        >
                        <label class="custom_check me-3">
                          <input
                            type="checkbox"
                            v-model="form.tax_enabled"
                            true-value="1"
                            false-value="0"
                            name="tax_enabled"
                          />
                          <span class="checkmark"></span> Enable Tax
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group-item pt-lg-2 mb-4">
                  <div class="row align-item-center">
                    <div class="form-group col-lg-3">
                      <label class="d-flex justify-content-between"
                        >Customer
                        <span
                          @click="openAddCustomerModal"
                          class="badge rounded-pill badge-outline-dark"
                          style="cursor: pointer"
                          >+ Add New</span
                        ></label
                      >
                      <selectMenu
                        v-model="selectedCustomer"
                        :options="customers"
                        label="Customer"
                        optionAttribute="name"
                        placeholder="Search Customer"
                        searchAttribute="name"
                      />
                    </div>
                    <div class="form-group col-lg-3">
                      <label>Currency</label>
                      <b-form-select
                        v-model="form.currency"
                        class="form-control"
                        required
                      >
                        <b-form-select-option value="" selected
                          >Select currency</b-form-select-option
                        >
                        <b-form-select-option
                          v-for="(currency, index) in allCurrencyCodes"
                          :key="index"
                          :value="currency.code"
                          >{{
                            `${currency.code} : ${currency.currency}`
                          }}</b-form-select-option
                        >
                      </b-form-select>
                    </div>
                    <div class="form-group col-lg-3">
                      <label>Estimate Date</label>
                      <datepicker
                        v-model="startdate"
                        class="picker"
                        :editable="true"
                        :clearable="false"
                      />
                    </div>

                    <div class="form-group col-lg-3">
                      <label>Due Date</label>
                      <datepicker
                        v-model="enddate"
                        class="picker"
                        :editable="true"
                        :clearable="false"
                      />
                    </div>
                  </div>
                </div>


                               <!-- Add Newitems mobile -->
    <div class="modal custom-modal fade" id="addNewItem_modal" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <form @submit.prevent="addItemMobile" class="modal-content">
          <div class="modal-header border-0 pb-0">
            <div class="form-header modal-header-title text-start mb-0">
              <h4 class="mb-0">Add New Item</h4>
            </div>
            <button
              type="button"
              class="close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span class="align-center" aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
        
              <div class="col-lg-12 col-md-12">
                <div class="form-group">
                  <label>Product / Service</label> <span class="text-danger">*</span>
                  <textarea
                    type="text"
                    v-model="mobileItem.name"
                    class="form-control"
                    placeholder="Enter Description"
                    required
                  />
                </div>
                <div class="form-group">
                  <label>Quantity</label> <span class="text-danger">*</span>
                  <input
                    type="number"
                    @keyup="calculateMobileAmount()"
                    v-model="mobileItem.quantity"
                    class="form-control"
                    placeholder="Enter Quantity"
                    required
                  />
                </div>
                <div class="form-group">
                  <label>Price</label> <span class="text-danger">*</span>
                  <input
                    type="number"
                    @keyup="calculateMobileAmount()"
                    v-model="mobileItem.price"
                    class="form-control"
                    placeholder="Enter Price"
                    required
                  />
                </div>
                <div class="form-group">
                  <label>Discount</label> <span class="text-danger">*</span>
                  <input
                    type="number"
                    v-model="mobileItem.discount"
                    class="form-control"
                    placeholder=""
                    required
                  />
                </div>
                <div class="form-group">
                  <label>Amount</label> <span class="text-danger">*</span>
                  <input
                    type="number"
                    v-model="mobileItem.amount"
                    class="form-control"
                    placeholder="Enter Amount"
                    required
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer add-tax-btns">
            <a
              href="javascript:;"
              data-bs-dismiss="modal"
              class="btn add-btn-cancel-btn"
              >Cancel</a
            >
            <button type="submit" class="btn btn-primary add-tax-save-btn" @click="addItemMobile">
              Add Item
            </button>
          </div>
        </form>
      </div>
    </div>


                <div>
                  <div class="card-table2">
                    <div class="card-body p-0">
                      <div class="table-responsive2">
                        <a-table
                          class="stripped table-hover"
                          :columns="columns"
                          :data-source="form.items"
                          :pagination="false"
                        >
                          <template #bodyCell="{ column, record, index }">
                            <template v-if="column.key === 'index'">
                              <span>{{ index + 1 }}</span>
                            </template>
                            <template v-if="column.key === 'name'">
                              <div class="form-group">
                                <input
                                  style="width: 100%"
                                  v-model="record.name"
                                  type="text"
                                  class="form-control1 no-scrollbar d-inline-block d-lg-none"
                                />
                                <textarea
                                  style="width: 100%"
                                  v-model="record.name"
                                  class="form-control1 no-scrollbar d-none d-lg-block"
                                  rows="1"
                                ></textarea>
                              </div>
                            </template>
                            <template v-if="column.key === 'quantity'">
                              <input
                                type="number"
                                @keyup="calculateAmount(index)"
                                v-model="record.quantity"
                                style="width: 100%"
                                class="form-control1"
                              />
                            </template>
                            <template v-if="column.key === 'price'">
                              <input
                                type="number"
                                @keyup="calculateAmount(index)"
                                v-model="record.price"
                                style="width: 100%"
                                class="form-control1"
                              />
                            </template>

                            <template v-if="column.key === 'discount'">
                              <input
                                type="number"
                                v-model="record.discount"
                                @blur="fillEmptyDiscount"
                                style="width: 100%"
                                class="form-control1"
                              />
                            </template>
                            <template v-if="column.key === 'amount'">
                              <input
                                type="number"
                                v-model="record.amount"
                                style="width: 100%"
                                disabled
                                class="form-control1"
                              />
                            </template>
                            <template v-if="column.key === 'action'">
                              <a
                                class="btn-action-icon me-2"
                                @click="deleteItem(index)"
                                ><i
                                  class="far fa-trash-alt text-danger px-1"
                                ></i
                              ></a>
                            </template>
                          </template>
                        </a-table>
                      </div>
                    </div>
                    <div class="d-flex justify-content-start mt-2">
                      <a class="btn btn-greys me-2 d-none d-md-block" @click="addNewItem"
                        ><i class="fa fa-plus-circle text-success me-2"></i>Add
                        New Item</a
                      >
                       <a class="btn btn-greys d-md-none me-2" @click="addNewItemMobile"
                        ><i class="fa fa-plus-circle text-success me-2"></i>Add
                        New Item</a
                      >
                    </div>
                  </div>
                </div>

                <div class="form-group-item mt-3 mt-lg-0">
                  <div class="row align-items-end justify-content-end">
                    <div class="col-xl-5 col-md-5 col-lg-5 me-lg-5">
                      <div class="form-group-bank">
                        <div class="row">
                          <div class="col-lg-4 col-md-12 mb-2">
                            <span
                              @click="openModal"
                              class="badge rounded-pill badge-outline-dark"
                              style="cursor: pointer"
                              >Add to total</span
                            >
                          </div>
                        </div>
                        <div class="invoice-total-box">
                          <div class="invoice-total-inner">
                            <p>
                              Subtotal
                              <span
                                >{{ form.currency.slice(0, 3) }}
                                {{ addCurrencyComma(taxableAmount) }}</span
                              >
                            </p>
                            <p>
                              Discount
                              <span
                                >- {{ form.currency.slice(0, 3) }}
                                {{ addCurrencyComma(totalProductDiscount) }}</span
                              >
                            </p>
                            <p
                              v-for="(discount, index) in form.more_discount"
                              :key="index"
                            >
                              {{ discount.description }}
                              <span
                                ><a
                                  @click="deleteDiscount(discount.description)"
                                  ><i
                                    class="feather feather-trash-2 me-2"
                                  ></i></a
                                >- {{ form.currency.slice(0, 3) }}
                                {{ addCurrencyComma(discount.value) }}</span
                              >
                            </p>
                            <p
                              v-for="(charge, index) in form.additional_charges"
                              :key="index"
                            >
                              {{ charge.description }}
                              <span
                                ><a @click="deleteCharge(charge.description)"
                                  ><i
                                    class="feather feather-trash-2 me-2"
                                  ></i></a
                                >+ {{ form.currency.slice(0, 3) }}
                                {{ addCurrencyComma(charge.value) }}
                              </span>
                              <span></span>
                            </p>
                            <p v-if="form.tax_enabled === '1'">
                              {{ `VAT(${tax_percentage}%)` }}
                              <span
                                >{{ form.currency.slice(0, 3) }}
                                {{ addCurrencyComma(vat) }}</span
                              >
                            </p>
                          </div>
                          <div class="invoice-total-footer">
                            <h4>
                              Total
                              <span
                                >{{ form.currency.slice(0, 3) }}
                                {{ addCurrencyComma(totalAmount) }}</span
                              >
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-4">
                  <!-- Editor -->
                  <div class="col-md-12 col-lg-12">
                    <label class="text-black">Notes</label>
                    <div class="card-body p-0">
                      <QuillEditor
                        style="height: 250px;"
                        toolbar="full"
                        v-model:content="form.notes"
                        contentType="html"
                        theme="snow"
                      />
                    </div>
                  </div>
                  <!-- /Editor -->
                </div>
                <div class="add-customer-btns text-end">
                  <router-link to="/estimates" class="btn customer-btn-cancel"
                    >Cancel</router-link
                  >
                  <b-button
                    @click="addEstimate"
                    :disabled="isLoading"
                    variant="primary"
                  >
                    <span
                      v-if="isLoading"
                      class="spinner-border spinner-border-sm me-1"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span v-if="!isLoading">Add Estimate</span>
                    <span v-if="isLoading">Adding...</span>
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->

    <!-- Add Charges -->
    <div class="modal custom-modal fade" id="addcharges_modal" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <form @submit.prevent="addNewCharge" class="modal-content">
          <div class="modal-header border-0 pb-0">
            <div class="form-header modal-header-title text-start mb-0">
              <h4 class="mb-0">Add to Total</h4>
            </div>
            <button
              type="button"
              class="close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span class="align-center" aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-4 col-md-12">
                <div class="form-group">
                  <label>Select type</label> <span class="text-danger">*</span>
                  <select v-model="addtototal" class="form-select" required>
                    <option :value="null" selected>Add to total</option>
                    <option value="charges">Charges</option>
                    <option value="discount">Discount</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-12 col-md-12">
                <div class="form-group">
                  <label>Description</label> <span class="text-danger">*</span>
                  <input
                    type="text"
                    v-model="newCharge.description"
                    class="form-control"
                    placeholder="Enter Description"
                    required
                  />
                </div>
                <div class="form-group">
                  <label>Amount</label> <span class="text-danger">*</span>
                  <input
                    type="number"
                    v-model="newCharge.value"
                    class="form-control"
                    placeholder="Enter Amount"
                    required
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer add-tax-btns">
            <a
              href="javascript:;"
              data-bs-dismiss="modal"
              class="btn add-btn-cancel-btn"
              >Cancel</a
            >
            <button type="submit" class="btn btn-primary add-tax-save-btn">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
    <!-- Add Charges -->
    <addcustomer @closeAddModal="closeAddCustomerModal" />
  </div>
  <!-- /Main Wrapper -->
</template>

<script setup>
import { ref, onMounted, computed, watch } from "vue";
import { useStore } from "vuex";
import { Modal } from "bootstrap";
import { addCurrencyComma } from "@/assets/composables/currency";
import {
  formatDateToDashDigits,
  formatDateStrings,
  calculatePreferredDueDate,
} from "@/assets/composables/date";
import { createToaster } from "@meforma/vue-toaster";
const toast = createToaster({ position: "top-right", duration: 3000 });
const currencyCodes = require("currency-codes");

// Get all currency 
const allCurrencyCodes = computed(() => {
  return currencyCodes.data.map((currency) => currency);
});

const store = useStore();
const addChargesModal = ref(null);
const addCustomerModal = ref(null);
const startdate = ref(new Date());
const enddate = ref(new Date());
const isLoading = ref(false);
const taxableAmount = ref(0);
const addNewItemModal = ref("")
const totalCharges = ref(0);
const totalDiscount = ref(0);
const totalAmount = ref(0);
const addtototal = ref(null);
const tax_percentage = ref(0);
const vat = ref(0);
const totalProductDiscount = ref(0);
const selectedCustomer = ref(null)
const user = computed(() => {
  return store.getters["auth/user"];
});
const username = computed(() => store.getters["auth/user"]);
const form = ref({
  estimate_id: null,
  customer_id: null,
  date: "",
  due_date: "",
  tax_enabled: 0,
  currency: "",
  notes: `Thank you for choosing ${username.value.name}.`,
  description: "",
  additional_charges: [],
  more_discount: [],
  items: [
    {
      name: "",
  quantity: 1,
  price:null,
  amount:null,
  discount:0
    }
  ]
});

const isMobile = ref(false);

const checkScreenSize = () => {
  isMobile.value = window.innerWidth <= 768; // Mobile threshold (can be adjusted)
};

// Update the items array based on screen size
watch(isMobile, (newValue) => {
  if (newValue) {
    form.value.items = [];
  } else {
    form.value.items = [
      {
        name: "",
        quantity: 1,
        price: 0,
        amount: 0,
        discount: 0
      }
    ];
  }
});
const newCharge = ref({
  description: "",
  mode: "amount",
  value: null,
});

watch(
  startdate,
  (newValue) => {
    form.value.date = formatDateToDashDigits(newValue);
  },
  { immediate: true }
);

watch(selectedCustomer, (newVal) => {
  form.value.customer_id =  newVal.id
});
watch(startdate, (newValue) => {
  const newdate = calculatePreferredDueDate(
    newValue,
    parseInt(settings?.value.preferred_due_date)
  );
  enddate.value = formatDateStrings(newdate);
});
watch(
  enddate,
  (newValue) => {
    form.value.due_date = formatDateToDashDigits(newValue);
  },
  { immediate: true }
);

watch(
  () => form.value.items,
  () => {
    calculateTotalAmount();
  },
  { deep: true }
);
watch(
  () => form.value.more_discount,
  () => {
    calculateTotalAmount();
  },
  { deep: true }
);
watch(
  () => form.value.additional_charges,
  () => {
    calculateTotalAmount();
  },
  { deep: true }
);
watch(
  () => form.value.tax_enabled,
  () => {
    calculateTotalAmount();
  },
  { deep: true }
);

const calculateAmount = (index) => {
  form.value.items[index].amount =
    form.value.items[index].quantity * form.value.items[index].price;
};

const calculateCharges = () => {
  let totalcharges = 0;
  totalCharges.value = 0;
  for (let i = 0; i < form.value.additional_charges.length; i++) {
    const item = form.value.additional_charges[i];
    totalcharges += item.value;
  }
  totalCharges.value = totalcharges;
};
const calculateDiscount = () => {
  let totaldiscount = 0;
  totalDiscount.value = 0;
  for (let i = 0; i < form.value.more_discount.length; i++) {
    const item = form.value.more_discount[i];
    totaldiscount += item.value;
  }
  totalDiscount.value = totaldiscount;
};
const calculateTotalAmount = () => {
  // Caalculate Total amount
  let totalproductamount = 0;
  let totalproductdiscount = 0;
  let totalamount = 0;
  for (let i = 0; i < form.value.items.length; i++) {
    const item = form.value.items[i];
    totalproductamount += item.amount;
    if (item.discount == "" || item.discount == null) {
      totalproductdiscount += 0;
    } else {
      totalproductdiscount += (item.discount / 100) * item.amount;
    }
  }
  taxableAmount.value = totalproductamount;
  totalProductDiscount.value = totalproductdiscount;
  calculateCharges();
  calculateDiscount();
  let T1 = totalproductamount + totalCharges.value;
  let T2 = totalproductdiscount + totalDiscount.value;
  totalamount = T1 - T2;
  // Calculate Tax
  if (form.value.tax_enabled === "1") {
    vat.value = (tax_percentage.value * totalamount) / 100;
    totalAmount.value = totalamount + vat.value;
  } else {
    totalAmount.value = totalamount;
  }
};

const fillEmptyDiscount = () => {
  for (let i = 0; i < form.value.items.length; i++) {
    const item = form.value.items[i];
    if (item.discount == "" || null) {
      item.discount = 0;
    }
  }
};


const addNewItem = () => {
  const lastIndex = form.value.items.length - 1;
  if (form.value.items.length !== 0 && form.value.items[lastIndex].quantity === null) {
    toast.error("Please fill the quantity field!");
  } else {
    form.value.items.push({
      name: "",
      quantity: 1,
      price: null,
      amount: null,
      discount: 0,
    });
  }
};
const mobileItem =ref( {
  name: "",
  quantity: 1,
  price:null,
  amount:null,
  discount:0
})

const calculateMobileAmount = ()=>{
  mobileItem.value.amount =
  mobileItem.value.quantity * mobileItem.value.price;
}
const addItemMobile = ()=>{
  const existingItemIndex = form.value.items.findIndex(item => {
    return item.name === mobileItem.value.name && 
           item.quantity === mobileItem.value.quantity &&
           item.price === mobileItem.value.price;
  });

  if (existingItemIndex === -1  && mobileItem.value.name && mobileItem.value.quantity !==  null  &&  mobileItem.value.price !== null) {
   
    form.value.items.push(mobileItem.value);

    mobileItem.value={
  name: "",
  quantity: 1,
  price:null,
  amount:null,
  discount:0
}
addNewItemModal.value.hide()
  } 

}


const deleteItem = (index) => {
  form.value.items.splice(index, 1);
};

const deleteCharge = (charge_name) => {
  const ChargeIndex = form.value.items.findIndex(
    (item) => item.description === charge_name
  );
  form.value.additional_charges.splice(ChargeIndex, 1);
};

const deleteDiscount = (discount_name) => {
  const DiscountIndex = form.value.items.findIndex(
    (item) => item.description === discount_name
  );
  form.value.more_discount.splice(DiscountIndex, 1);
};

const openAddCustomerModal = () => {
  addCustomerModal.value.show();
};
const closeAddCustomerModal = () => {
  addCustomerModal.value.hide();
};

const addNewItemMobile = ()=>{
  addNewItemModal.value.show();
}
const openModal = () => {
  addChargesModal.value.show();
  addtototal.value = null;
  newCharge.value = {
    description: "",
    mode: "amount",
    value: null,
  };
};

const addNewCharge = () => {
  if (
    addtototal.value === "charges" &&
    newCharge.value.description != "" &&
    newCharge.value.value != ""
  ) {
    form.value.additional_charges.push(newCharge.value);
    addChargesModal.value.hide();
  } else if (
    addtototal.value === "discount" &&
    newCharge.value.description != "" &&
    newCharge.value.value != ""
  ) {
    form.value.more_discount.push(newCharge.value);
    addChargesModal.value.hide();
    console.log(form.value.more_discount);
  } else {
    toast.error("Fill all required fields!");
  }
};

const customers = computed(() => {
  return store.getters["customer/customers"].data;
});

const getCustomers = () => {
  let data = {
    page: 1,
    per_page: 1000,
    query: "",
  };
  store.dispatch("customer/getCustomers", data);
};

const columns = [
  {
    title: "#",
    key: "index",
    sorter: true,
  },
  {
    title: "Product / Service",
    key: "name",
    sorter: true,
  },
  {
    title: "Quantity",
    key: "quantity",
    sorter: true,
  },
  {
    title: "Price",
    key: "price",
    sorter: true,
  },
  {
    title: "Discount",
    key: "discount",
    sorter: true,
  },
  {
    title: "Amount",
    key: "amount",
    sorter: true,
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];

const estimates = computed(() => {
  return store.getters["estimate/estimates"].data;
});

const settings = computed(() => {
  return store.getters["settings/settings"];
});

const getSettings = () => {
  store.dispatch("settings/getSettings").then(() => {
    form.value.currency = settings.value.currency;
    form.value.tax_enabled = settings.value.auto_enable_tax.toString();
    if (settings.value.preferred_due_date != null) {
      const newdate = calculatePreferredDueDate(
        startdate.value,
        parseInt(settings.value.preferred_due_date)
      );
      enddate.value = formatDateStrings(newdate);
    }
    tax_percentage.value = settings.value.tax_percentage;
  });
};

const getEstimates = () => {
  let data = {
    page: 1,
    per_page: 10000,
  };
  store.dispatch("estimate/getEstimates", data).then(() => {
    form.value.estimate_id = `${settings.value.estimate_prefix}000${
      estimates.value.length + 1
    }`;
  });
};

const addEstimate = () => {
  if (form.value.customer_id === null) {
    toast.error("No customer selected, please select a customer");
  } else {
    isLoading.value = true;
    store
      .dispatch("estimate/addEstimates", form.value)
      .then(() => {
        isLoading.value = false;
      })
      .catch(() => {
        isLoading.value = false;
      });
  }
};

onMounted(() => {


  store.dispatch("auth/getUser");
  checkScreenSize();

  getSettings();
  getEstimates();
  getCustomers();
  addChargesModal.value = new Modal(
    document.getElementById("addcharges_modal"),
    {
      backdrop: "static",
      keyboard: false,
    }
  );
  addNewItemModal.value = new Modal(
    document.getElementById("addNewItem_modal"),
    {
      backdrop: "static",
      keyboard: false,
    }
  );
  addCustomerModal.value = new Modal(
    document.getElementById("addcustomer_modal"),
    {
      backdrop: "static",
      keyboard: false,
    }
  );
});
</script>

<style>
.no-scrollbar {
  overflow: hidden;
  font-size: 14px;
  color: #8f9bba;
}
</style>
